import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {FeedMatrixLine} from './FeedMatrixLine';

export class FeedMatrixPack extends BasicEntity {
lines: {[key: string]: FeedMatrixLine};
modulation: number | null;
}

